import axios from 'axios';
import qs from 'qs';

export const getSurveys = (params: Record<string, any>) =>
  axios.get(`/api/v1/surveys?${qs.stringify(params)}`);

export const getSchoolSurveys = (params: Record<string, any>) =>
  axios.get(`/api/v1/surveys?${qs.stringify(params)}`);

export const getSurveysByStudentId = ({
  studentId,
  params,
}: {
  studentId: string;
  params: Record<string, any>;
}) =>
  axios.get(`/api/v1/surveys/students/${studentId}?${qs.stringify(params)}`);
